import styled from '@emotion/styled'
import { Button, Grid, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { StyledPageTitle } from './CommonStyles'
import { writeMessageToDB } from '../utils/fetchDB'
import { sendNewMessage } from '../utils/mail'
import swal from 'sweetalert'
import useRWD from '../utils/useRWD'

const initFormValue = {
  company_name: '',
  name: '',
  job_title: '',
  email: '',
  message: '',
}

const StyledTextField = styled(TextField)`
font-family: GenYOGothic2TW;
  background-color: #eaeaea;
  color: #707070;

  & .MuiInputLabel-root {
    color: #707070;
    font-size: 1.5rem;
    font-weight: bold;
  }

  & .MuiInputLabel-root.Mui-focused {
    color: #707070;
    font-weight: bold;
    font-size: 1.25rem;
  }

  & .MuiInputBase-input {
    color: #707070;
    font-size: 1.5rem;
  }
`
const StyledButton = styled(Button)`
font-family: GenYOGothic2TW;
  margin-top: 1.5em;
  padding: 0.4em 4em;
  background-color: #d0d0d0;
  color: #707070;
  font-size: 1.5rem;
  font-weight: normal;

  &:hover {
    color: #ffffff;
    background-color: #b2b1b1;
  }
`

export default function ContactUs() {
  const [formValue, setFormValue] = useState(initFormValue)
  const {isPhone} = useRWD()

  function handleChange(e) {
    setFormValue({ ...formValue, [e.target.id]: e.target.value })
  }
  async function handleSubmit(e) {
    e.preventDefault()
    try {
      await writeMessageToDB(formValue)
      await sendNewMessage(formValue)
      swal({
        title: '感謝您的填寫！我們將盡快與您聯絡',
        icon: 'success',
      })
    } catch (error) {
      swal({
        title: '寄送失敗',
        icon: 'error',
      })
      console.error(error)
    } finally {
      setFormValue(initFormValue)
    }
  }

  return (
    <div style={{ width: isPhone ? '100%' : '70%', margin: 'auto' }}>
      <StyledPageTitle variant="h3">聯絡我們</StyledPageTitle>
      <form id="form_contact" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledTextField
              id="company_name"
              name="compamy_name"
              variant="filled"
              label="公司名稱"
              value={formValue.company_name}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <StyledTextField
              id="name"
              name="name"
              variant="filled"
              label="姓名"
              value={formValue.name}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <StyledTextField
              id="job_title"
              name="job_title"
              variant="filled"
              label="職稱"
              value={formValue.job_title}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              id="email"
              name="email"
              variant="filled"
              label="電子信箱"
              value={formValue.email}
              onChange={handleChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              id="message"
              name="message"
              variant="filled"
              label="請在這裡輸入您的訊息"
              required
              value={formValue.message}
              onChange={handleChange}
              fullWidth
              rows={10}
              multiline
            />
          </Grid>
          <Grid item xs={12}>
            <StyledButton type="submit" variant="contained">
              送出
            </StyledButton>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}
